const links = [
  {
    label: "Github",
    url: "https://github.com/lparanhos"
  },
  {
    label: "Linkedin",
    url: "https://linkedin.com/in/leandro-p-5770b886"
  },
  {
    label: "Twitter",
    url: "https://twitter.com/LeandroGabrie41"
  }
];

export default links;
